const context = require.context('.', true, /\.\/.*\/index\.js$/);
context.keys().forEach(path => {
  const componentName = path.replace(/^.+\/([^/]+)\/index\.js/, '$1');
  context(path).default
  && (module.exports[componentName] = context(path).default);
});
